import { apiSlice } from "../../apiSlice";

export const CreadoxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createDoImpo: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx`,
        method: "POST",
        body: parameters,
        headers: {
          'modulecima': 'Modimpxx',
          'X-Idempotency-Key': parameters.idempotencyKey
        },
      }),
      invalidatesTags: ["Create", "Consult"],
    }),
    getManifiestoByDo: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx/getManifiestoByDo`,
        method: "GET",
        params: { ...parameters },
        headers: { 'modulecima': 'Modimpxx' },
      }),
    }),
    getGroupByImpoPerfil: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx/getGroupByPerfil/${parameters.CLIIDXXX}`,
        method: "GET",
        headers: { 'modulecima': 'Modimpxx' },
      }),
    }),
    getDataTracking: builder.query({
      query: (parameters) => {
        let headers = {};
        headers['modulecima'] = parameters.MODURLXX.toLowerCase();
        return {
          url: `/${parameters.MODURLXX}/${parameters.PRODURLX}`,
          params: { ...parameters },
          headers: headers,
        };
      },
      providesTags: ["Create"],
    }),
    validateInvoiceRestrictions: builder.query({
      query: (parameters) => ({
        url: `/Modimpxx/Trackimp/Creadoxx/validateInvoiceRestrictions`,
        method: "POST",
        body: parameters,
        headers: { 'modulecima': 'Modimpxx' },
      }),
    }),
  }),
});

export const {
  useCreateDoImpoMutation,
  useLazyGetManifiestoByDoQuery,
  useLazyGetGroupByImpoPerfilQuery,
  useGetDataTrackingQuery,
  useLazyGetDataTrackingQuery,
  useValidateInvoiceRestrictionsQuery,
} = CreadoxxApiSlice;
